/* pdp.js - Addlore PDP fold 1. Built 15-09-2026.

   THIS FILE MAY ONLY OPEN AND CLOSE DIALOGS. It must never write a word, a
   price, an image or a layout into the page. Every panel inside every dialog is
   already in the HTML Shopify sends; which one shows is radio state and CSS.
   If a future change makes this file set textContent or innerHTML, that change
   is a rule-0 violation and belongs somewhere else, or nowhere.

   No setInterval. No polling. No MutationObserver. Two listeners, delegated.
   Loaded with defer, so it cannot block the parse or the LCP image.
*/
(function () {
  'use strict';

  function dlg(id) { return document.getElementById(id); }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-pdp-close]');
    if (close) {
      var own = close.closest('dialog');
      if (own && own.open) own.close();
      return;
    }

    var tile = e.target.closest('.pdp-ing-tile');
    if (tile) {
      /* Check the radio for the tile the visitor pressed, then open. Setting a
         radio is the same state change the visitor would make by clicking the
         label - it selects, it does not author content. */
      var r = document.getElementById('pdping-' + tile.getAttribute('data-ing'));
      if (r) r.checked = true;
      var d = dlg('pdp-ing-dlg');
      if (d && !d.open) d.showModal();
      return;
    }

    /* Tap the stage to open the gallery full-size. Which photograph shows is the
       pdpslide radio and CSS - this only opens the dialog. */
    var stage = e.target.closest('[data-pdp-lb]');
    if (stage) {
      var lb = dlg('pdp-lb-dlg');
      if (lb && !lb.open) lb.showModal();
      return;
    }

    /* Any control carrying data-pdp-open names the dialog it opens. One branch
       for every dialog the page will ever have, instead of one branch each. */
    var opener = e.target.closest('[data-pdp-open]');
    if (opener) {
      var od = dlg(opener.getAttribute('data-pdp-open'));
      if (od && !od.open) { e.preventDefault(); od.showModal(); }
      return;
    }

    /* 17-09-2026, Ajay: tapping the gift photos opens the gifts sheet - in the two-tin card and in
       Build your pair. NOT in the "Add a second tin for just Rs450" strip: that whole strip is the label
       that switches to the two-tin pack, and Ajay's instruction is that tapping it picks the pack. */
    var gifts = e.target.closest('.pdp-gifts-open, .pdp-gift .pdp-gwrap');
    if (gifts) {
      e.preventDefault();
      var g = dlg('pdp-gifts-dlg');
      if (g && !g.open) g.showModal();
      return;
    }

    /* Click on the backdrop closes. A dialog's own box is inside its rect, so
       compare against it rather than trusting event.target alone. */
    if (e.target.tagName === 'DIALOG' && e.target.open) {
      var b = e.target.getBoundingClientRect();
      var outside = e.clientX < b.left || e.clientX > b.right ||
                    e.clientY < b.top || e.clientY > b.bottom;
      if (outside) e.target.close();
    }
  });

  /* Escape is native on <dialog>. Left/right arrows in the lightbox move the same
     pdpslide radio the labels move - no content is written. */
  document.addEventListener('keydown', function (e) {
    var lb = dlg('pdp-lb-dlg');
    if (!lb || !lb.open) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var rs = document.querySelectorAll('input.pdp-r[name="pdpslide"]');
    if (!rs.length) return;
    var at = 0;
    for (var i = 0; i < rs.length; i++) { if (rs[i].checked) { at = i; break; } }
    var to = e.key === 'ArrowRight' ? (at + 1) % rs.length
                                    : (at - 1 + rs.length) % rs.length;
    rs[to].checked = true;
    e.preventDefault();
  });

  /* Left and right arrows move between ingredients while the dialog is open.
     They move the same radio the labels move - no content is written. */
  document.addEventListener('keydown', function (e) {
    var d = dlg('pdp-ing-dlg');
    if (!d || !d.open) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var rs = d.querySelectorAll('.pdp-ir');
    if (!rs.length) return;
    var at = 0;
    for (var i = 0; i < rs.length; i++) { if (rs[i].checked) { at = i; break; } }
    var to = e.key === 'ArrowRight' ? (at + 1) % rs.length
                                    : (at - 1 + rs.length) % rs.length;
    rs[to].checked = true;
    e.preventDefault();
  });

  /* ---- the films rail arrows -------------------------------------------
     The ONLY thing this does is scroll a container the visitor asked to be
     scrolled, and grey an arrow out when there is nothing further that way.
     It writes no text and creates no elements. Delete it and the rail still
     scrolls by trackpad, wheel and touch - the arrows would simply sit idle.
     R1-safe: JavaScript responding to a visitor action, never deciding what
     the page says. */
  var rail = document.querySelector('.pdp-reels-sc');
  if (rail) {
    var navBtns = document.querySelectorAll('.pdp-reels-arw');

    var railStep = function () {
      var t = rail.querySelector('.pdp-reel');
      return t ? t.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    };

    var railSync = function () {
      var max = rail.scrollWidth - rail.clientWidth;
      for (var i = 0; i < navBtns.length; i++) {
        var dir = navBtns[i].getAttribute('data-reel');
        navBtns[i].disabled = dir === 'prev' ? rail.scrollLeft <= 4
                                             : rail.scrollLeft >= max - 4;
      }
    };

    /* 26-09-2026. THIS IS NOT A SIMPLIFICATION TARGET. A bare `rail.scrollLeft +=` was
       swallowed: the handler fired and scrollLeft stayed 0, so the rail never scrolled and every
       tile past the fourth was unreachable on all three products. Measured on live Spirited:
       clientWidth 1040, scrollWidth 1858, scroll range 818px, three arrow presses moved it 0px.
       Setting scroll-behavior to 'auto' first makes the same assignment land exactly.

       snippets/adl-reels-fix.liquid recorded this in 2026-09 for the PREVIOUS rail
       (.adl-reelsc): "assigning scrollLeft while scroll-behavior is 'smooth' is SWALLOWED on
       this page - the handler fires, scrollLeft stays 0. 'auto' always works. step() tries
       smooth, verifies after 420ms, forces with 'auto'. Do not simplify this away."
       That rail was replaced by .pdp-reels-sc and the lesson was lost with it. Same fix, again.

       So: ask for smooth, then verify and force. Where smooth works the visitor gets the glide;
       where it is swallowed the rail still moves. */
    var railTo = function (left) {
      var max = rail.scrollWidth - rail.clientWidth;
      left = Math.max(0, Math.min(max, left));
      try { rail.scrollTo({ left: left, behavior: 'smooth' }); } catch (err) { rail.scrollLeft = left; }
      setTimeout(function () {
        if (Math.abs(rail.scrollLeft - left) > 4) {
          var keep = rail.style.scrollBehavior;
          rail.style.scrollBehavior = 'auto';
          rail.scrollLeft = left;
          rail.style.scrollBehavior = keep;
        }
        /* 26-09-2026: railSync runs off the scroll event, and a scrollTo that lands exactly where the
           rail already is fires no scroll event - so the next arrow stayed lit at the end of the rail.
           Measured: scrollLeft 294 against a max of 294 with the button still enabled. Sync once the
           movement has settled, whether or not anything moved. */
        railSync();
      }, 420);
    };

    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.pdp-reels-arw') : null;
      if (!b) return;
      railTo(rail.scrollLeft + (b.getAttribute('data-reel') === 'prev' ? -railStep() : railStep()));
    });

    rail.addEventListener('scroll', railSync, { passive: true });
    window.addEventListener('resize', railSync);
    railSync();
  }

  /* ---- the review rail's two arrows (added 16-09-2026) ----------------------
     Every card is server-rendered by pdp-reviews; the topic filter and "Read more"
     are CSS. This only scrolls the rail when an arrow is pressed and greys an arrow
     at either end. It writes no text and creates no element. */
  var rvRail = document.querySelector('.pdp-rv-rail');
  if (rvRail) {
    var rvBtns = document.querySelectorAll('.pdp-rv-nav');
    var rvStep = function () {
      var c = rvRail.querySelector('.pdp-rv-card:not([style*="none"])');
      var cards = rvRail.querySelectorAll('.pdp-rv-card');
      for (var k = 0; k < cards.length; k++) { if (cards[k].offsetParent !== null) { c = cards[k]; break; } }
      return c ? (c.getBoundingClientRect().width + 14) * 3 : rvRail.clientWidth;
    };
    var rvSync = function () {
      var max = rvRail.scrollWidth - rvRail.clientWidth;
      for (var i = 0; i < rvBtns.length; i++) {
        rvBtns[i].disabled = rvBtns[i].getAttribute('data-rv') === 'prev'
          ? rvRail.scrollLeft <= 4 : rvRail.scrollLeft >= max - 4;
      }
    };
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.pdp-rv-nav') : null;
      if (!b) return;
      /* a direct jump, as the reels rail does: smooth scrolling does not run in a
         background tab, so it could not be verified and the 3-Sep source used 'instant' */
      rvRail.scrollLeft += b.getAttribute('data-rv') === 'prev' ? -rvStep() : rvStep();
    });
    /* pressing a review photo opens that review's photos in #pdp-rv-lb. The photos are
       server-rendered; this unhides one group, opens the dialog and scrolls to the photo. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-rv-lb]') : null;
      if (!b) return;
      var d = document.getElementById('pdp-rv-lb'); if (!d || !d.showModal) return;
      var gs = d.querySelectorAll('[data-rv-g]'), g = null;
      for (var i = 0; i < gs.length; i++) {
        var on = gs[i].getAttribute('data-rv-g') === b.getAttribute('data-rv-lb');
        gs[i].hidden = !on; if (on) g = gs[i];
      }
      if (!g) return;
      d.showModal();
      var row = g.querySelector('.pdp-rv-lbr'), k = +b.getAttribute('data-rv-i') || 0;
      if (row) { row.scrollLeft = (row.clientWidth + 10) * k; rvLbSync(row); }
    });
    /* review lightbox: arrows and thumbnails move the photo row; the thumb of the photo on
       screen gets aria-current. 17-09-2026. Scroll and one attribute - no text, no markup. */
    var rvLbSync = function (row) {
      var g = row.closest('.pdp-rv-lbg'); if (!g) return;
      var k = Math.round(row.scrollLeft / (row.clientWidth + 10));
      var n = row.children.length;
      var th = g.querySelectorAll('[data-rv-go]');
      for (var i = 0; i < th.length; i++) th[i].setAttribute('aria-current', i === k ? 'true' : 'false');
      var ar = g.querySelectorAll('[data-rv-step]');
      for (var j = 0; j < ar.length; j++) ar[j].disabled = ar[j].getAttribute('data-rv-step') === '-1' ? k <= 0 : k >= n - 1;
    };
    document.addEventListener('click', function (e) {
      var s = e.target.closest ? e.target.closest('[data-rv-step],[data-rv-go]') : null;
      if (!s) return;
      var row = s.closest('.pdp-rv-lbg').querySelector('.pdp-rv-lbr'); if (!row) return;
      var w = row.clientWidth + 10;
      var k = s.hasAttribute('data-rv-go') ? +s.getAttribute('data-rv-go')
            : Math.round(row.scrollLeft / w) + (+s.getAttribute('data-rv-step'));
      row.scrollTo({ left: Math.max(0, k) * w, behavior: 'smooth' });
    });
    var rvRows = document.querySelectorAll('.pdp-rv-lbr');
    for (var q = 0; q < rvRows.length; q++) {
      rvRows[q].addEventListener('scroll', function () { rvLbSync(this); }, { passive: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'pdp-rvf') { rvRail.scrollLeft = 0; rvSync(); }
    });
    rvRail.addEventListener('scroll', rvSync, { passive: true });
    window.addEventListener('resize', rvSync);
    rvSync();
  }

  /* ---- the comparison section's two buttons ----------------------------
     The markup is server-rendered by sections/adl-usvsthem. Its two buttons
     do not have their own form on purpose: "add to cart" scrolls to the page's
     REAL add-to-cart and clicks it, so the page has exactly one add-to-cart
     path; "choose a different pack" scrolls to the pack picker.

     V2 wires these from snippets/adl-uvs-art with a setInterval that polls 40
     times at 150ms - six seconds of polling on every load - because on V2 the
     markup used to be cloned in by script and might not exist yet. It is
     server-rendered now, so a delegated listener is enough and nothing polls.

     This writes no text. V2's version also rewrote the button's label, which
     fought adl-ctapin rebuilding the same spans; the sub-line here is CSS. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    /* 17-09-2026, Ajay: every button that says "add to cart" adds to cart. The FAQ and closing-panel
       buttons are links to the buy box (so they still work with script off); with script they press the
       buy box's own button, exactly as the comparison button does. */
    var add = e.target.closest('.pdp-faq-btn, .pdp-ind-btn');
    if (add) {
      e.preventDefault();
      var cta = document.querySelector('.pdp-form .pdp-cta:not([style*="display: none"])');
      if (!cta) {
        var all = document.querySelectorAll('.pdp-form .pdp-cta');
        for (var i = 0; i < all.length; i++) {
          if (all[i].offsetParent !== null) { cta = all[i]; break; }
        }
      }
      if (cta) { cta.scrollIntoView({ block: 'center' }); cta.click(); }
      return;
    }
  });

  /* ---- the delivery pincode ---------------------------------------------
     V2 checks no serviceability list: it tests the six-digit format and then
     says it ships there. This does the same, and ONLY after the visitor presses
     check. The resting sentence is server-rendered, so the page is never blank
     or wrong before this runs, and with JavaScript off it simply stays.

     This is the one place pdp.js writes text. It is confined to an element
     whose entire purpose is to answer a question the visitor just asked, it
     writes no price, no claim about the product and no markup, and the page
     reads correctly without it. Anything beyond this belongs elsewhere. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('[data-pdp-pin]');
    if (!b) return;
    var input = document.getElementById('pdp-pin-in');
    var msg = document.getElementById('pdp-pin-msg');
    if (!input || !msg) return;
    var v = (input.value || '').trim();
    if (!/^[1-9][0-9]{5}$/.test(v)) {
      msg.textContent = 'That does not look like a six digit pincode.';
      msg.setAttribute('data-state', 'bad');
      return;
    }
    /* 16-09-2026: no longer says "We ship to <pincode>" - nothing is checked, so it must not promise. */
    msg.textContent = 'Free shipping. Dispatched within 24 hrs; delivery time to ' + v + ' is the courier\u2019s estimate.';
    msg.setAttribute('data-state', 'ok');
  });

  /* ---- dragging the corner film ------------------------------------------
     V2's is draggable (cursor:grab, touch-action:none, measured). This is a
     pointer drag and nothing else: it moves one fixed box the visitor is
     holding. It writes no text and creates no element, and if it never runs the
     film still plays, still closes and still enlarges. */
  var hf = document.getElementById('pdp-hf');
  if (hf && window.PointerEvent) {
    var dragging = false, sx = 0, sy = 0, ox = 0, oy = 0;
    hf.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.pdp-hf-b')) return;      /* the two controls win */
      var r = hf.getBoundingClientRect();
      dragging = true; sx = e.clientX; sy = e.clientY; ox = r.left; oy = r.top;
      hf.classList.add('is-dragging');
      hf.setPointerCapture(e.pointerId);
    });
    hf.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var w = hf.offsetWidth, h = hf.offsetHeight;
      var x = Math.min(Math.max(ox + e.clientX - sx, 8), window.innerWidth - w - 8);
      var y = Math.min(Math.max(oy + e.clientY - sy, 8), window.innerHeight - h - 8);
      hf.style.left = x + 'px'; hf.style.top = y + 'px';
      hf.style.right = 'auto'; hf.style.bottom = 'auto';
    });
    var stopDrag = function (e) {
      if (!dragging) return;
      dragging = false; hf.classList.remove('is-dragging');
      try { hf.releasePointerCapture(e.pointerId); } catch (err) {}
    };
    hf.addEventListener('pointerup', stopDrag);
    hf.addEventListener('pointercancel', stopDrag);
  }

  /* ---- the corner film and the corner buttons, by scroll position ----------
     17-09-2026, Ajay. Two classes on <html>, nothing else: no text, no markup, no polling.
     FILM: hidden once the add-to-cart form's top is on screen (40px above the bottom edge) or
     above it; back only when the reader is above it again.
     BUTTONS: on once the top of #questions has scrolled above the viewport top; off above it.
     A passive scroll listener, one read per frame. NOT IntersectionObserver: measured on the
     V3 preview, a jump (the arrow link, a fast fling, Home) crosses no intersection edge, so the
     observer never fired and both classes stuck in the wrong state. V3-67. */
  var hfForm = document.getElementById('pdp-form');
  var jumpFaq = document.getElementById('questions');
  if (hfForm || jumpFaq) {
    var corner = document.documentElement, cornerQueued = false;
    var cornerPaint = function () {
      cornerQueued = false;
      if (hfForm) {
        var fr = hfForm.getBoundingClientRect();
        corner.classList.toggle('pdp-hf-hush', fr.top < window.innerHeight - 40);
        /* sticky bar: away while any part of the page's own add-to-cart form is on screen */
        corner.classList.toggle('pdp-sb-hush', fr.top < window.innerHeight && fr.bottom > 0);
      }
      if (jumpFaq) corner.classList.toggle('pdp-jump-on', jumpFaq.getBoundingClientRect().top < 0);
    };
    var cornerQueue = function () {
      if (cornerQueued) return;
      cornerQueued = true;
      if (document.hidden) setTimeout(cornerPaint, 16); else window.requestAnimationFrame(cornerPaint);
    };
    window.addEventListener('scroll', cornerQueue, { passive: true });
    window.addEventListener('resize', cornerQueue, { passive: true });
    cornerPaint();
  }

  /* ---- the film viewer (#pdp-reel-dlg) ------------------------------------------
     17-09-2026, ported from V2 adl-reelviewer. Every panel, price and button is in the served
     HTML; swiping is native scroll-snap. This only: opens at a panel, scrolls on an arrow or a
     key, marks the dot and arrows for the panel on screen, plays that panel's film from 0 and
     pauses the rest, flips the ONE sound state, and pauses everything on close. */
  var rvw = document.getElementById('pdp-reel-dlg');
  if (rvw) {
    var rvwSc = rvw.querySelector('[data-rvw-sc]');
    var rvwDots = rvw.querySelectorAll('.pdp-rvw-dots i');
    var rvwArw = rvw.querySelectorAll('[data-rvw-step]');
    var rvwSnd = rvw.querySelector('[data-rvw-sound]');
    var rvwMuted = true, rvwAt = -1, rvwQ = false;
    var rvwIdx = function () { return Math.round(rvwSc.scrollLeft / (rvwSc.clientWidth || 1)); };
    /* returns a starter bound to ONE element - see the note in rvwPaint */
    var adlPanelStarter = function (el) {
      return function () {
        try { el.currentTime = 0; } catch (err) {}
        var pr = el.play(); if (pr && pr.catch) pr.catch(function () {});
      };
    };
    var rvwPaint = function () {
      rvwQ = false;
      var k = rvwIdx(), n = rvwSc.children.length;
      for (var i = 0; i < rvwDots.length; i++) rvwDots[i].className = i === k ? 'on' : '';
      for (var a = 0; a < rvwArw.length; a++) rvwArw[a].disabled = rvwArw[a].getAttribute('data-rvw-step') === '-1' ? k <= 0 : k >= n - 1;
      if (k === rvwAt) return;
      rvwAt = k;
      var vids = rvwSc.querySelectorAll('video');
      for (var v = 0; v < vids.length; v++) {
        var vid = vids[v];
        vid.muted = rvwMuted;
        if (rvw.open && rvwSc.children[k] && rvwSc.children[k].contains(vid)) {
          if (window.adlGoFull) window.adlGoFull(vid);
          /* the panels ship preload="none", so on open there is nothing buffered to play. Ask for the
             data first, then start once the browser has some - play() on an empty element is a coin
             toss. Same discipline as the rail. */
          if (vid.preload === 'none') { vid.preload = 'auto'; vid.load(); }
          /* 26-09-2026. THE CLOSURE BUG THAT STOPPED THE VIEWER PLAYING AT ALL.
             This loop declares `var vid`, which is FUNCTION scoped, not block scoped - every iteration
             shares one binding. When the play call was wrapped in a closure for the loadeddata path,
             that closure captured the shared `vid`, so by the time the event fired the loop had ended
             and `vid` pointed at the LAST panel's video. Opening any panel played the wrong element and
             the one on screen sat frozen. It only bit when readyState < 2 - i.e. first open, because
             these panels ship preload="none" - so a cached film took the synchronous path and worked,
             which is why it looked intermittent.
             The element is now passed in by value. Do not inline this back into the loop. */
          var starter = adlPanelStarter(vid);
          if (vid.readyState >= 2) { starter(); }
          else { vid.addEventListener('loadeddata', starter, { once: true }); }
        } else { vid.pause(); }
      }
    };
    var rvwGo = function (k, smooth) {
      var n = rvwSc.children.length;
      k = Math.max(0, Math.min(n - 1, k));
      rvwSc.scrollTo({ left: k * rvwSc.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    };
    var rvwOpen = function (k) {
      if (rvw.open) return;
      rvwMuted = true; rvwAt = -1;
      rvwSnd.setAttribute('aria-pressed', 'false');
      /* 26-09-2026. PAUSE THE PAGE'S OWN FILMS FIRST. Since the corner film became a rail tile too,
         the same film exists as up to THREE <video> elements - the corner player, its rail tile, and
         this viewer's panel 0 - and the in-view autoplay was decoding all of them at once. Three
         simultaneous decodes of a 3.4 MB HLG film is wasted battery at best, and on a GPU compositing
         HDR layers it is how you get the stacked, half-painted viewer Ajay screenshotted. Nothing on
         the page can be seen while a modal dialog is up, so none of them should be running. The
         in-view observer restarts whichever is still on screen after the dialog closes. */
      var pageVids = document.querySelectorAll('[data-pdp-vid]');
      for (var pv = 0; pv < pageVids.length; pv++) {
        try { pageVids[pv].pause(); } catch (err) {}
      }
      rvw.showModal();
      rvwGo(k, false);
      rvwPaint();
    };
    rvwSc.addEventListener('scroll', function () {
      if (rvwQ) return; rvwQ = true; window.requestAnimationFrame(rvwPaint);
    }, { passive: true });
    rvw.addEventListener('close', function () {
      var vids = rvwSc.querySelectorAll('video');
      for (var v = 0; v < vids.length; v++) vids[v].pause();
      rvwAt = -1;
    });
    rvw.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { rvwGo(rvwIdx() + 1, true); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { rvwGo(rvwIdx() - 1, true); e.preventDefault(); }
    });
    var hfMoved = false, hfX = 0, hfY = 0;
    var hfEl = document.getElementById('pdp-hf');
    if (hfEl) {
      hfEl.addEventListener('pointerdown', function (e) { hfMoved = false; hfX = e.clientX; hfY = e.clientY; });
      hfEl.addEventListener('pointermove', function (e) {
        if (Math.abs(e.clientX - hfX) + Math.abs(e.clientY - hfY) > 8) hfMoved = true;
      });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-rvw-sound]')) {
        rvwMuted = !rvwMuted;
        rvwSnd.setAttribute('aria-pressed', rvwMuted ? 'false' : 'true');
        var vids = rvwSc.querySelectorAll('video');
        for (var v = 0; v < vids.length; v++) vids[v].muted = rvwMuted;
        return;
      }
      var st = e.target.closest('[data-rvw-step]');
      if (st) { rvwGo(rvwIdx() + (+st.getAttribute('data-rvw-step')), true); return; }
      /* 26-09-2026: a tile is role="button" and opens the viewer; its own controls must not. */
      if (e.target.closest('[data-reel-ctl]')) return;
      var op = e.target.closest('[data-rvw-open]');
      if (op) { rvwOpen(+op.getAttribute('data-rvw-open') || 0); return; }
      /* the corner film itself is the door - but not its close, and not the end of a drag */
      if (hfEl && e.target.closest('#pdp-hf') && !e.target.closest('.pdp-hf-x') && !hfMoved) rvwOpen(0);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target.closest ? e.target.closest('.pdp-reel[data-rvw-open]') : null;
      if (!t) return;
      e.preventDefault(); rvwOpen(+t.getAttribute('data-rvw-open') || 0);
    });
  }

  /* ---- adding... / added to cart -------------------------------------------
     17-09-2026, Ajay: on a slow connection a customer must see the press land and must not be able to
     add twice. On the first submit of #pdp-form (any of its buttons - buy box, sticky bar, film viewer)
     this sets html[data-cart]="adding"; CSS swaps every add-to-cart label for "adding..." and stops
     presses. adl-cart-hook opens the cart drawer when Shopify confirms the add; that flips the state to
     "added" for 1.8 s, then the buttons come back. If the drawer never opens (network error), the state
     clears after 10 s so the page is never stuck. Registered on WINDOW in the capture phase so it runs
     before the cart hook's document listener and can stop a second submit outright.
     Words are CSS content; this sets one attribute and nothing else. */
  var cartBusy = false, cartTimer = 0;
  function cartState(v) {
    if (v) document.documentElement.setAttribute('data-cart', v);
    else document.documentElement.removeAttribute('data-cart');
  }
  function cartRelease() { cartBusy = false; cartState(''); }
  var cartDrawer = document.getElementById('adlCartDrawer');
  if (cartDrawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (cartBusy && cartDrawer.classList.contains('open')) {
        cartState('added');
        clearTimeout(cartTimer);
        cartTimer = setTimeout(cartRelease, 1200);
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
  /* ---- film tile controls, 26-09-2026 (Ajay) --------------------------------
     Play/pause and mute/unmute on each film, rendered by snippets/pdp-reel-ctls.liquid.
     One delegated listener, no per-tile binding, so tiles added later work with no change.
     SOUND IS EXCLUSIVE: unmuting one film mutes every other one on the page, because two films in
     the rail can be on screen together and two soundtracks at once is not a thing anyone wants.
     A film the visitor paused carries data-adl-hold, which the in-view autoplay above honours. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-reel-play],[data-reel-mute]');
    if (!btn) return;
    var host = btn.closest('.pdp-reel, .pdp-hf');
    var vid = host ? host.querySelector('video') : null;
    if (!vid) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.hasAttribute('data-reel-play')) {
      if (vid.paused) {
        vid.dataset.adlHold = '0';
        window.adlGoFull(vid);
        if (vid.preload === 'none') { vid.preload = 'auto'; vid.load(); }
        var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Pause film');
      } else {
        vid.dataset.adlHold = '1';
        try { vid.pause(); } catch (err) {}
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Play film');
      }
      return;
    }
    var unmute = vid.muted;
    if (unmute) {
      /* unmuting is a deliberate act: give them the whole film, from the start */
      window.adlGoFull(vid);
      var pl = vid.play(); if (pl && pl.catch) pl.catch(function () {});
      var all = document.querySelectorAll('.pdp-reel video, .pdp-hf video');
      for (var i = 0; i < all.length; i++) {
        if (all[i] === vid) continue;
        all[i].muted = true;
        var host2 = all[i].closest('.pdp-reel, .pdp-hf');
        var ob = host2 ? host2.querySelector('[data-reel-mute]') : null;
        if (ob) { ob.setAttribute('aria-pressed', 'true'); ob.setAttribute('aria-label', 'Unmute film'); }
      }
    }
    vid.muted = !unmute;
    btn.setAttribute('aria-pressed', vid.muted ? 'true' : 'false');
    btn.setAttribute('aria-label', vid.muted ? 'Unmute film' : 'Mute film');
  }, true);

  /* The button must follow the FILM, not the other way round. These films are started by three
     different things - a tap, the in-view autoplay, the viewer - and the browser can pause one on its
     own in a background tab. Listening to the video's own events is the only state that cannot drift.
     play/pause do not bubble, hence the capture phase. */
  (function adlSyncReelCtls() {
    var sync = function (v, playing) {
      var host = v.closest ? v.closest('.pdp-reel, .pdp-hf') : null;
      var btn = host ? host.querySelector('[data-reel-play]') : null;
      if (!btn) return;
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      btn.setAttribute('aria-label', playing ? 'Pause film' : 'Play film');
    };
    document.addEventListener('play', function (e) {
      if (e.target && e.target.tagName === 'VIDEO') sync(e.target, true);
    }, true);
    document.addEventListener('pause', function (e) {
      if (e.target && e.target.tagName === 'VIDEO') sync(e.target, false);
    }, true);
  })();

  /* 19-09-2026 speed pass: the two films are served poster-only (preload="none", no autoplay), so nothing
     downloads 1.6 MB before the page is usable. A film starts when the visitor taps it, or when the film
     viewer opens it. No polling, no timers - one delegated listener, the same as every other control here. */
  document.addEventListener('click', function (e) {
    /* 26-09-2026: the play/pause and mute buttons live INSIDE the film, so without this the tap
       handler would restart the film the moment the visitor pressed pause. */
    if (e.target.closest && e.target.closest('[data-reel-ctl]')) return;
    var v = e.target.closest ? e.target.closest('[data-pdp-vid]') : null;
    if (!v) {
      var wrap = e.target.closest ? e.target.closest('.pdp-reel-cover, .pdp-hf') : null;
      v = wrap ? wrap.querySelector('[data-pdp-vid]') : null;
    }
    if (!v) return;
    if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
    if (window.adlGoFull) window.adlGoFull(v);
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }, true);

  /* 20-09-2026 - THE FILMS AUTOPLAY WHEN THEY SCROLL INTO VIEW, NOT ON LOAD. Founder's choice,
     asked and answered 20-09-2026, after he noticed the corner reel no longer moved.

     HISTORY, so nobody "fixes" this back and forth again:
       V2 served `muted autoplay loop playsinline preload="metadata"`. On 19-09-2026 the speed pass
       removed `autoplay` because PageSpeed measured the two films at 1,040 KB + 576 KB - 1.6 MB of
       video downloading before the page was usable - and replaced it with the tap handler above.
       That was a V2 behaviour removed without asking (V3-108). This restores the movement without
       paying for it before first paint.

     WHY IT IS NOT AN `autoplay` ATTRIBUTE: an `autoplay` attribute starts the download during
     parse, which is exactly the 1.6 MB we removed. The markup therefore keeps `preload="none"` and
     NO `autoplay`; nothing is fetched until the film is actually on screen AND the page has loaded.

     GUARDS, all deliberate:
       - runs only after `load`, then inside an idle callback, so it can never compete with LCP;
       - `prefers-reduced-motion: reduce` - nothing autoplays. House motion rule;
       - Data Saver or a 2G connection - nothing autoplays;
       - no IntersectionObserver - does nothing, and the tap handler above still works;
       - pauses again when the film leaves the viewport, so it does not burn battery off-screen.

     SCOPE: `[data-pdp-vid]` is exactly the two visible films (the hero corner reel and the reels
     rail cover). The film INSIDE the viewer dialog deliberately has no such attribute - it is opened
     by the visitor and must not start on its own. */
  /* ---- PREVIEW CLIPS, 26-09-2026 (Ajay) -------------------------------------
     "only auto play a good part of the video and the real video when the user interacts".
     A film carrying data-clip="start,end" autoplays ONLY that window, on a loop, muted. The moment the
     visitor does something deliberate - presses play, unmutes, or opens the full-screen viewer - the
     clip is dropped and the whole film plays from the beginning. Short films carry no data-clip and
     are unaffected; only the two corner films and the 55-second review have one.
     adlFull on the element is the latch: once set, nothing puts the film back into preview. */
  /* data-clip is a LIST of windows, "6,11;16,21;24,29" - the preview plays each in turn and loops back
     to the first. One window is still valid ("24,30"); it is just a list of one. Ajay, 26-09: "can we
     use mix of section why are good". */
  window.adlClipsOf = function (v) {
    if (!v || v.dataset.adlFull === '1') return null;
    var c = v.getAttribute('data-clip');
    if (!c) return null;
    var out = [], parts = c.split(';');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].split(','), a = parseFloat(p[0]), b = parseFloat(p[1]);
      if (isFinite(a) && isFinite(b) && b > a) out.push({ a: a, b: b });
    }
    return out.length ? out : null;
  };
  /* the window the film is in, or the first one */
  window.adlClipOf = function (v) {
    var list = window.adlClipsOf(v);
    if (!list) return null;
    var i = parseInt(v.dataset.adlSeg || '0', 10);
    if (!(i >= 0 && i < list.length)) i = 0;
    return list[i];
  };
  window.adlGoFull = function (v) {
    if (!v) return;
    v.dataset.adlFull = '1';
    /* 26-09-2026: seek ONLY if the browser has metadata. Assigning currentTime at readyState 0 is
       dropped silently, and pairing it with an immediate play() is exactly what stalled THE REVIEW's
       autoplay. Not repeating that here. A film with no metadata starts at 0 anyway. */
    if (v.readyState >= 1) { try { v.currentTime = 0; } catch (err) {} }
  };
  /* keep a clipped film inside its window. timeupdate fires ~4x a second, which is close enough for a
     loop point nobody is measuring, and far cheaper than a timer per film. */
  document.addEventListener('timeupdate', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO') return;
    var list = window.adlClipsOf(v);
    if (!list) return;
    var i = parseInt(v.dataset.adlSeg || '0', 10);
    if (!(i >= 0 && i < list.length)) i = 0;
    /* only the UPPER bound advances. A lower-bound reset also fires while a film is still seeking into
       its window, and seek-on-seek is what stalls playback. */
    if (v.currentTime >= list[i].b) {
      var n = (i + 1) % list.length;
      v.dataset.adlSeg = String(n);
      try { v.currentTime = list[n].a; } catch (err) {}
    }
  }, true);

  (function adlReelAutoplayInView() {
    if (!('IntersectionObserver' in window)) return;
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq && mq.matches) return;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && (conn.saveData === true || /(^|\W)(slow-)?2g$/.test(conn.effectiveType || ''))) return;

    function tryPlay(v) {
      if (v.dataset.adlHold === '1') return;
      if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
      /* 26-09-2026: THE REVIEW did not autoplay and the clip is why. Its window starts at 24s, and a
         film served preload="none" has NO metadata yet - readyState 0 - so currentTime cannot be set.
         The seek was silently dropped, playback began at 0, and the timeupdate guard immediately saw
         a position below the window and seeked again, which stalls the element. The short films have
         no clip, never seek, and were unaffected - which is exactly the pattern Ajay saw.
         Seek only once the browser knows the duration; until then, wait for loadedmetadata. */
      var c = window.adlClipOf(v);
      var go = function () {
        var cc = window.adlClipOf(v);
        if (cc && (v.currentTime < cc.a || v.currentTime >= cc.b)) { try { v.currentTime = cc.a; } catch (err) {} }
        var q = v.paused ? v.play() : null;
        if (q && q.catch) q.catch(function () {});
      };
      if (!c || v.readyState >= 1) { go(); }
      else { v.addEventListener('loadedmetadata', go, { once: true }); }
      if (!v.dataset.adlRetry) {
        v.dataset.adlRetry = '1';
        v.addEventListener('canplay', function () {
          if (v.paused && v.dataset.adlWant === '1' && v.dataset.adlHold !== '1') {
            var q = v.play(); if (q && q.catch) q.catch(function () {});
          }
        });
      }
    }

    function start() {
      var vids = document.querySelectorAll('[data-pdp-vid]');
      if (!vids.length) return;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var en = entries[i], v = en.target;
          /* adlHold is set when the visitor presses pause. Honour it: scrolling the tile back into
             view must not restart a film they deliberately stopped. */
          /* 26-09-2026, Ajay: "they only play when someone reaches that section, so people don't reach
             it half way". The film used to keep whatever position it had, so a tile that had edged onto
             screen once was mid-way by the time the visitor arrived. Entering view now RESTARTS it -
             from the clip point on a clipped film, from zero otherwise. */
          if (en.isIntersecting) {
            v.dataset.adlWant = '1';
            /* the seek is left to tryPlay, which waits for metadata. Setting currentTime here on a
               film that has none is what broke THE REVIEW. Only an already-loaded film is rewound. */
            if (v.dataset.adlHold !== '1') {
              v.dataset.adlSeg = '0';
              if (v.readyState >= 1) {
                var cc = window.adlClipOf(v);
                try { v.currentTime = cc ? cc.a : 0; } catch (err) {}
              }
              tryPlay(v);
            }
          }
          else { v.dataset.adlWant = '0'; if (!v.paused) { try { v.pause(); } catch (err) {} } }
        }
      /* 0.35 let a tile start when barely a third of it had appeared, so the visitor arrived partway
         through. 0.6 means the tile is properly on screen before anything moves. */
      }, { threshold: 0.6 });
      for (var i = 0; i < vids.length; i++) io.observe(vids[i]);
    }

    function kick() {
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
      idle(start, { timeout: 2000 });
    }
    if (document.readyState === 'complete') kick();
    else window.addEventListener('load', kick, { once: true });
  })();

  /* 17-09-2026, Ajay: "adding.../added works sometimes", and the button inside the film viewer
     added the tin behind the open dialog. A submit event does not always reach us (the film
     button posts a different form), so the STATE is set on the CLICK of any add-to-cart control,
     and any dialog the button sits in is closed so the cart drawer is the thing on top. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.pdp-cta,.pdp-rvw-cta,.pdp-sb-btn,.pdp-faq-btn,.pdp-ind-btn,.bp-cta,[data-bp-add],[data-bp-one]') : null;
    if (!t) return;
    var dlg = t.closest('dialog');
    if (dlg && dlg.open) setTimeout(function () { try { dlg.close(); } catch (err) {} }, 250);
    if (t.hasAttribute('data-bp-add') || t.hasAttribute('data-bp-one')) return;
    if (cartBusy) return;
    cartBusy = true;
    cartState('adding');
    clearTimeout(cartTimer);
    cartTimer = setTimeout(cartRelease, 10000);
  }, true);

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'pdp-form') return;
    if (cartBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    cartBusy = true;
    cartState('adding');
    cartTimer = setTimeout(cartRelease, 10000);
    var rvOpen = document.getElementById('pdp-reel-dlg');
    if (rvOpen && rvOpen.open) rvOpen.close();
  }, true);

  /* ---- Build your pair (snippets/pdp-pair.liquid) ------------------------------------------
     17-09-2026, Ajay. The visitor presses "add to cart" in the pair block: read the cart, then add
     this page's tin AND the chosen second tin - or only the second if this page's tin is already in
     the cart, so "second tin for just" stays true. Same adding/added states and the same drawer as
     the buy box. Nothing on the page is rewritten. */
  /* quick look: "add to cart" for that one tin */
  document.addEventListener('click', function (e) {
    var o = e.target.closest ? e.target.closest('[data-bp-one]') : null;
    if (!o || cartBusy) return;
    cartBusy = true; cartState('adding');
    clearTimeout(cartTimer); cartTimer = setTimeout(cartRelease, 10000);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +o.getAttribute('data-bp-one'), quantity: 1 }] }) })
      .then(function (res) {
        if (!res.ok) { cartRelease(); return; }
        cartState('added');
        setTimeout(function () {
          var d = o.closest('dialog'); if (d && d.open) d.close();
          if (window.adlCartDrawer) window.adlCartDrawer.open(); else cartRelease();
        }, 900);
      })
      .catch(cartRelease);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-bp-add]') : null;
    if (!b || cartBusy) return;
    var r = document.querySelector('.bp-r:checked');
    if (!r) return;
    var first = +b.getAttribute('data-first'), second = +r.value;
    cartBusy = true; cartState('adding');
    clearTimeout(cartTimer); cartTimer = setTimeout(cartRelease, 10000);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (c) {
        var has = (c.items || []).some(function (i) { return i.variant_id === first; });
        var items = has ? [{ id: second, quantity: 1 }]
          : (first === second ? [{ id: first, quantity: 2 }] : [{ id: first, quantity: 1 }, { id: second, quantity: 1 }]);
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      })
      .then(function (res) {
        if (!res || !res.ok) { cartRelease(); return; }
        cartState('added');
        setTimeout(function () { if (window.adlCartDrawer) window.adlCartDrawer.open(); else cartRelease(); }, 900);
      })
      .catch(cartRelease);
  });
})();
